var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQaAddLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1975",
    x: 0,
    y: 0,
    width: 186,
    height: 186,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qa-add-lock",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -12)",
    filter: "url(#Rectangle_1975)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1975-2",
    "data-name": "Rectangle 1975",
    width: 150,
    height: 150,
    rx: 25,
    transform: "translate(12 12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1990",
    "data-name": "Group 1990",
    transform: "translate(-1569.442 -186.427)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_320",
    "data-name": "Line 320",
    y2: 23.828,
    transform: "translate(1685.36 215.418)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321",
    "data-name": "Line 321",
    y2: 23.72,
    transform: "translate(1697.22 227.332) rotate(90)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1996",
    "data-name": "Group 1996",
    transform: "translate(-1892.955 -432.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M45.423,76.291H.75V42.478a10.86,10.86,0,0,1,10.86-10.86H34.564a10.86,10.86,0,0,1,10.86,10.86Z",
    transform: "translate(1944.868 471.404)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M8.741,24.587V17.071a16.321,16.321,0,1,1,32.642,0V25.23",
    transform: "translate(1942.837 479.25)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M34.887,54.571A6.981,6.981,0,1,0,23.7,60.136v9.173h8.4V60.136A6.963,6.963,0,0,0,34.887,54.571Z",
    transform: "translate(1939.74 467.344)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaAddLock);
export default __webpack_public_path__ + "static/media/qa-add-lock.adad7c9ac1834cf8fee39d1b31dbcfe0.svg";
export { ForwardRef as ReactComponent };